import React, { useContext, useEffect, useState } from "react";
// import "./Edit_User_Modal.css";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import Edit_User_Modal_Frame from "../../Common_Component/Common_Modal/Edit_User_Modal/Edit_User_Modal_Frame/Edit_User_Modal_Frame";
import {
  Update,
  findOne,
} from "../../../utils/apis/teen_patti/teen_patti_amount/index";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { HTTPS } from "../../../utils/common";
import { Context } from "../../../utils/context";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
import Select from "react-select";
function Edit(props) {
  const { UnauthorizedLogOut, IMG_URL } = useContext(Context);
  const id = props.show;
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    watch,
    getValues,
    control,
  } = useForm();
  const imageFile = watch("image");
  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("amount", data?.amount);
      // sendData.append("max_amount", data?.max_amount);
      sendData.append("max_chaal_amount", data?.max_chaal_amount);
      sendData.append("max_amount_on_table", data?.max_amount_on_table);
      const result = await Update(id, sendData);
      const response = result.data;

      if (HTTPS.ALREADY_REPORTED.code !== response?.code) {
        await setShowModal({
          code: response.code,
          message: response.data,
        });

        setTimeout(() => {
          setShowModal(0);
          props.onHide();
        }, 1000);
      } else {
        setError("name", {
          message: response?.errors?.name?.msg,
        });
      }
    } catch (error) {
      setError("name", {
        type: "manual", // Optional but helps to indicate it's a manual error
        message: error?.response?.data?.errors,
      });
      await UnauthorizedLogOut(error);
      console.error(error.message);
    }
  };

  const GetEditData = async () => {
    if (id) {
      const response = await findOne(id);
      reset(response?.data?.data);
    }
  };
  useEffect(() => {
    GetEditData();
  }, [id]);

  const [UsersType, setUsersType] = useState([
    {
      value: "customers",
      label: "customers",
      name: "users_type",
    },
    {
      value: "agents",
      label: "agents",
      name: "users_type",
    },
  ]);

  return (
    <>
      <section>
        <Modal
          {...props}
          className="Edit_User_Modal modal_holder"
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered>
          <Modal_Heading modalHeading={"Edit Teen Patti Table Amount"} />
          <div className="modal-body-holder">
            {/* <Edit_User_Modal_Frame /> */}
            <Modal.Body>
              <div className="main-form-holder">
                <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="row">
                      <div className="col-md-12 col-sm-12 mt-3">
                        <Form.Group
                          className="form-field"
                          controlId="formBasicEmail">
                          <Form.Label>Amount*</Form.Label>
                          <Form.Control
                            type="number"
                            name="amount"
                            placeholder="Amount"
                            className={classNames("", {
                              "is-invalid": errors?.amount,
                            })}
                            {...register("amount", {
                              required: "Amount is required",
                            })}
                          />
                          {errors.amount && (
                            <span className="text-danger">
                              {errors.amount.message}
                            </span>
                          )}
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="row">
                      <div className="row">
                        <div className="col-md-12 col-sm-12 mt-3">
                          <Form.Group
                            className="form-field"
                            controlId="formBasicEmail">
                            <Form.Label>Max Blind Limit*</Form.Label>
                            <Form.Control
                              type="number"
                              name="max_amount"
                              placeholder="Max Blind Limit"
                              className={classNames("", {
                                "is-invalid": errors?.max_amount,
                              })}
                              {...register("max_amount", {
                                required: "Max Blind Limit is required",
                              })}
                            />
                            {errors.max_amount && (
                              <span className="text-danger">
                                {errors.max_amount.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                  </div>*/}

                  <div className="row">
                    <div className="row">
                      <div className="row">
                        <div className="col-md-12 col-sm-12 mt-3">
                          <Form.Group
                            className="form-field"
                            controlId="formBasicEmail">
                            <Form.Label>Max Chaal Limit*</Form.Label>
                            <Form.Control
                              type="number"
                              name="max_chaal_amount"
                              placeholder="Max Chaal Limit"
                              className={classNames("", {
                                "is-invalid": errors?.max_chaal_amount,
                              })}
                              {...register("max_chaal_amount", {
                                required: "Max Chaal Limit is required",
                              })}
                            />
                            {errors.max_chaal_amount && (
                              <span className="text-danger">
                                {errors.max_chaal_amount.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="row">
                      <div className="row">
                        <div className="col-md-12 col-sm-12 mt-3">
                          <Form.Group
                            className="form-field"
                            controlId="formBasicEmail">
                            <Form.Label>Max Amount On table*</Form.Label>
                            <Form.Control
                              type="number"
                              name="max_amount_on_table"
                              placeholder="Max Amount On table"
                              className={classNames("", {
                                "is-invalid": errors?.max_amount_on_table,
                              })}
                              {...register("max_amount_on_table", {
                                required: "Max Amount On table is required",
                              })}
                            />
                            {errors.max_amount_on_table && (
                              <span className="text-danger">
                                {errors.max_amount_on_table.message}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>

                <div className="modal-footer-holder">
                  <div className="d-flex justify-content-center align-items-center">
                    <Button
                      className="search-btn mx-2"
                      onClick={() => {
                        props.onHide();
                        reset();
                      }}>
                      Cancel
                    </Button>

                    <Button
                      className="reset-btn mx-2"
                      type="button"
                      onClick={handleSubmit(onSubmit)}>
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Edit;
